import AlertsApiService from '@package/core/src/alerts/AlertsApiService';
import AlertsInteractor from '@package/core/src/alerts/AlertsInteractor';

import { apiClient } from '../services';
import { useStrictQuery } from '../useCustomQuery';

import { COOKIES_TERMS_QUERY_KEY } from './types';

const alertsService = new AlertsApiService(apiClient);
const alertsInteractor = new AlertsInteractor(alertsService);

const useCookiesTerms = () => {
  const { data: cookiesTermsHtmlContent } = useStrictQuery(
    [COOKIES_TERMS_QUERY_KEY],
    async () => {
      const res = await alertsInteractor.getCookiesTermsAlert();
      return res.data;
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    },
  );

  return { cookiesTermsHtmlContent };
};

export default useCookiesTerms;
